// A payment already made, as a History line shows it: bold, in the normal text
// colour. Amber means still owed and green a good state, so neither is used
// here. Settlement History and cash-advance repayment History both use this.
// (ZEN-802, ZEN-805)
export function PaidAmount({ testid, children }) {
  return <b data-testid={testid}>{children}</b>;
}
